import React from 'react'
import { Outlet } from 'react-router-dom'

const JobMorganic = () => {
  return (
    <Outlet/>
  )
}

export default JobMorganic